import AsyncStorage from '@react-native-async-storage/async-storage';
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface AuthState {
  isAuthenticated: boolean,
  accessToken: string | null,
  userDetails: any | null,
  fcmToken: string | null,
  assetData : any | null,
  userProfile: any | null,
  creditDetails: any | null,
  interestDetails: any | null,
  shortFallDetails: any | null,
  foreclosureDetails: any | null,
  pendingRequestDetails: any | null,
  pendingAccountRequest: any | null,
  loanDetails: any | null,
  isNotFirstDisbursal: boolean,
}



const initialState : AuthState = {
    isAuthenticated: false,
    accessToken: '',
    userDetails: null,
    fcmToken: null,
    userProfile:  null,
    assetData  : null,
    creditDetails: {},
    interestDetails: {},
    shortFallDetails: {},
    foreclosureDetails:{},
    pendingRequestDetails: {},
    pendingAccountRequest: {},
    loanDetails: {},
    isNotFirstDisbursal: false,
  };

export const authSlice = createSlice({
  name: 'auth',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    userAuthenticated: (state, action) => {
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
    },
    logout: (state) => {
        state.isAuthenticated = false;
        state.accessToken = null;
        state.userDetails = null;
        state.userProfile = null;
        state.assetData = null;
        state.creditDetails = {};
        state.interestDetails = {};
        state.shortFallDetails = {};
        state.foreclosureDetails = {};
        state.pendingRequestDetails = {};
        state.pendingAccountRequest = {};
        state.loanDetails = {};
        state.isNotFirstDisbursal = false;

    },
    updateUserDetails: (state , action : PayloadAction<Pick<AuthState, 'userDetails'>>) => {
        state.userDetails = action.payload;
    },
    updateUserProfile: (state , action : PayloadAction<Pick<AuthState, 'userProfile'>>) => {
      state.userProfile = action.payload;
    },
    updateCreditDetails: (state , action : PayloadAction<Pick<AuthState, 'creditDetails'>>) => {
      state.creditDetails = action.payload;
    },
    updateInterestDetails: (state , action : PayloadAction<Pick<AuthState, 'creditDetails'>>) => {
      state.interestDetails = action.payload;
    },
    updateUserDetailLinkedApp: (state , action : PayloadAction<Pick<AuthState, 'userDetails'>>) => {
      state.userDetails.linkedApplications[0] = action.payload;
    },
    saveFCMToken: (state, action: PayloadAction<string>) => {
      state.fcmToken = action.payload;
      AsyncStorage.setItem('fcmToken', action.payload);
    },
    clearFCMToken: (state) => {
      state.fcmToken = null;
      AsyncStorage.setItem('fcmToken', '');
    },
    updateAssetData : (state , action : PayloadAction<Pick<AuthState, 'assetData'>>) => {
      state.assetData = action.payload 
    },
    updateShortfallData : (state , action : PayloadAction<Pick<AuthState, 'shortFallDetails'>>) => {
      state.shortFallDetails = action.payload 
    },
    updateForeclosureDetails : (state , action : PayloadAction<Pick<AuthState, 'shortFallDetails'>>) => {
      state.foreclosureDetails = action.payload 
    },
    updatePendingRequestDetails : (state , action : PayloadAction<Pick<AuthState, 'pendingRequestDetails'>>) => {
      state.pendingRequestDetails = action.payload 
    },
    updatePendingAccountRequest : (state , action : PayloadAction<Pick<AuthState, 'pendingAccountRequest'>>) => {
      state.pendingAccountRequest = action.payload 
    },
    updateLoanDetails : (state , action : PayloadAction<Pick<AuthState, 'loanDetails'>>) => {
      state.loanDetails = action.payload 
    },
    updateIsNotFirstDisbursal: (state , action : PayloadAction<Pick<AuthState, 'isNotFirstDisbursal'>>) => {
      state.isNotFirstDisbursal = action.payload.isNotFirstDisbursal 
    },
  },
})

export const { 
  logout,
  updateUserDetails,
  updateUserProfile,
  updateUserDetailLinkedApp,
  userAuthenticated,
  saveFCMToken, clearFCMToken ,
  updateCreditDetails,
  updateInterestDetails,
  updateAssetData,
  updateShortfallData,
  updateForeclosureDetails,
  updatePendingRequestDetails,
  updatePendingAccountRequest,
  updateLoanDetails,
  updateIsNotFirstDisbursal
} = authSlice.actions

export default authSlice.reducer